export const ADD_CODES: { [key: string]: string } = {
  '25': 'Miscellaneous Add',
  '6B': 'PVD',
  '70': 'Temporary Flight Supervisor',
  '72': 'Temporary CA',
  AF: 'Reassignment',
  AP: 'Apportionment Pay',
  AR: 'Cross Division Reserve Preference',
  CD: 'CKA Proficiency Displacement',
  CH: 'Changeover Sequence',
  CK: 'Check Airman Added',
  DL: 'Restricted Duty',
  DM: 'Restricted Duty Maternity',
  DP: 'Displacement',
  DT: 'Displacement For IOE',
  IE: 'Initial Operating Experience',
  IH: 'Partial Paid Injury On Duty',
  JM: 'Junior Reserve Assignment',
  JU: 'Unconfirmed Junior Reserve Assignment',
  LR: 'Cross Division Junior Reserve Assignment',
  LU: 'Cross Division Junior Reserve Assignment, Unconfirmed',
  MF: 'Management Flying',
  MO: 'Make Up out of Base',
  MU: 'Make Up Flying',
  OV: 'Observation Ride',
  OG: 'Reserve Over Guarantee',
  OM: 'Over Maximum Reassignment',
  OT: 'Trip Trade With Open Time',
  PC: 'Check Airman Proficiency',
  PD: 'Proficiency Displacement',
  PM: 'Premium Flying',
  PR: 'Premium Flying, Reserve',
  PX: 'Paid Transfer',
  RA: 'Reassignment',
  RD: 'Replacement of DFP',
  RF: 'Reserve Preference Flying',
  RO: 'Recovery Obligation',
  RP: 'Report',
  RS: 'Reschedule',
  RU: 'Reserve Preference Flying - Unconfirmed',
  SD: 'Sequence Add TTOT',
  SP: 'Straight Pickup TTOT',
  TT: 'Trip Trade',
  TR: 'Transitional Reserve Day',
  VA: 'PVD Hurricane',
  W6: 'Wings PVD',
  WG: 'Wings',
  XC: 'Schedule Conflict',
  XM: 'EOM conflict; Confirmed Reserve',
  XU: 'EOM Conflict; Unconfirmed Reserve',
  YM: 'EOM Conflict; Confirmed Cross Division Reserve',
  YU: 'EOM Conflict; Unconfirmed Cross Division Reserve',
  '??': 'Unknown Add Code',
};
